import { trackDomainAnalytics } from 'lib/eventTracking'

export default trackDomainAnalytics('Characterizations')
